export default {
  TELEHEALTH_API_BASE_URL: process.env.REACT_APP_TELEHEALTH_API_BASE_URL,
  COGNITO_USER_POOL_CLIENT_ID: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  FORGOT_PASSWORD_URL: process.env.REACT_APP_FORGOT_PASSWORD_URL,
  ENVIRONMENT: process.env.ENVIRONMENT,
  SENTRY_DSN: process.env.SENTRY_DSN,
  RELEASE_TAG: JSON.stringify(process.env.RELEASE_TAG),
  POST_LOGGER_URL: process.env.REACT_APP_POST_LOGGER_URL,
  DATA_BRIDGE_RETRIEVE_URL: process.env.REACT_APP_DATA_BRIDGE_RETRIEVE_URL,
};
